import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { NavigationService } from '../../../shared/services/navigation.service';
import { ThemeService } from '../../services/theme.service';
import { Subscription } from 'rxjs';
import { ILayoutConf, LayoutService } from '../../services/layout.service';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { User } from 'src/app/models/user.model';
import { LocalStoreService } from '../../../shared/services/local-store.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-sidebar-side',
  templateUrl: './sidebar-side.component.html',
})
export class SidebarSideComponent implements OnInit, OnDestroy, AfterViewInit {
  public menuItems: any[];
  public hasIconTypeMenuItem: boolean;
  public iconTypeMenuTitle: string;
  private menuItemsSub: Subscription;
  public layoutConf: ILayoutConf;
  public userInfo: User;
  public currentUser: any;

  constructor(
    private navService: NavigationService,
    public themeService: ThemeService,
    private layout: LayoutService,
    public jwtAuth: AuthenticationService,
    private local: LocalStoreService
  ) {}

  ngOnInit() {
    this.iconTypeMenuTitle = this.navService.iconTypeMenuTitle;
    this.menuItems = _.sortBy(this.local.getItem('menu'), ['Index']);
    this.currentUser = this.local.getItem('currentUser');
    //Checks item list has any icon type.
    this.hasIconTypeMenuItem = !!this.menuItems.filter(
      (item) => item.type === 'icon'
    ).length;
    this.layoutConf = this.layout.layoutConf;
    this.userInfo = this.jwtAuth.currentUser;
  }
  ngAfterViewInit() {}
  ngOnDestroy() {
    if (this.menuItemsSub) {
      this.menuItemsSub.unsubscribe();
    }
  }
  upperCaseCompany(name) {
    return name.toUpperCase();
  }
  toggleCollapse() {
    if (this.layoutConf.sidebarCompactToggle) {
      this.layout.publishLayoutChange({
        sidebarCompactToggle: false,
      });
    } else {
      this.layout.publishLayoutChange({
        // sidebarStyle: "compact",
        sidebarCompactToggle: true,
      });
    }
  }
}
